import { createElement, FC, useContext, useEffect } from 'react';
import { useLocation } from 'react-router';
import { ScrollContainer } from 'react-router-scroll-4';

import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import Screen from '../screen/SignedInScreen';

type Props = {
  className?: string;
};

const SignedInScreenConnected: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);
  const user = state.authentication.signedInUser!;
  const location = useLocation();
  const mfaSetupRequired = !!user && !!user.mfaRequired && !user.otpEnabled;

  // organization_setting など以外でも getOrganizations するため
  useEffect(() => {
    if (
      user &&
      !mfaSetupRequired &&
      !(
        location.pathname.match(/^\/organization_setting\/.+/) ||
        location.pathname.match(/^\/account_setting\/.+/) ||
        location.pathname.match(/^\/organizations\/.+/)
      )
    ) {
      dependency.organizationUsecase.getOrganizations(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, mfaSetupRequired]);

  return !state.fatalError && state.authentication.signedInUser && (mfaSetupRequired || !state.authentication.done) ? (
    <ScrollContainer scrollKey="signed_in_screen">
      <Screen className={className} mfaSetupRequired={mfaSetupRequired} />
    </ScrollContainer>
  ) : null;
};

export default SignedInScreenConnected;
